import React, {useContext} from "react";
import { Link, useLocation } from "react-router-dom";
import { RiMenu4Line } from "react-icons/ri";
import NavbarContext from "../../context/navbar/NavbarContext";
import logo from "../../assets/images/logo.svg";
import MobileMenu from "../MobileMenu";

function NavBar() {
	// Using navbar context
	const {showMenu, toggleMenu} = useContext(NavbarContext)
  //assigning location variable
  const location = useLocation();

  //destructuring pathname from location
  const { pathname } = location;

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split("/");

  return (
    <>
	{showMenu && (<MobileMenu />)}
      <section className="py-4 md:py-8 px-4 md:px-0 bg-bg-white">
        <div className="container mx-auto">
          <div className="flex items-center justify-between  w-full">
            <div className="logo">
              <Link to="/">
                <img src={logo} alt="Protis" className="md:h-[44px] md:w-[150px] h-[38px] w-[120px] pointer-events-none" style={{ userDrag: 'none', userSelect: 'none' }} />
              </Link>
            </div>
            <ul className="items-center hidden sm:flex ">
              <li className={`px-4 mx-2 py-3 cursor-pointer font-normal`}>
                <Link
                  to="/"
                  className={`text-xl font-sfpro ${splitLocation[1] === ""
                      ? `text-black font-extrabold`
                      : `font-normal text-[#525665]`
                    }`}
                >
                  Home
                </Link>
              </li>
              <li className={`px-4 mx-2 py-3 cursor-pointer font-normal`}>
                <Link
                  to="/our-works"
                  className={`text-xl font-sfpro ${
                    splitLocation[1] === "our-works"
                      ? `text-black font-extrabold`
                      : `font-normal text-[#525665]`
                  }`}
                >
                  Our Works
                </Link>
              </li>
              <li className={`px-4 mx-2 py-3 cursor-pointer`}>
                <Link
                  to="/about-us"
                  className={`text-xl font-sfpro ${
                    splitLocation[1] === "about-us"
                      ? `text-black font-extrabold`
                      : `font-normal text-[#525665]`
                  }`}
                >
                  About Us
                </Link>
              </li>
              <li className={`px-4 mx-2 py-3 cursor-pointer`}>
                <Link
                  to="/contact-us"
                  className={`text-xl font-sfpro ${
                    splitLocation[1] === "contact-us"
                      ? `text-black font-extrabold`
                      : `font-normal text-[#525665]`
                  }`}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
            <div
              className="bg-white h-[28px] w-[28px] border border-black rounded-[8px] flex items-center justify-center md:hidden cursor-pointer"
              onClick={toggleMenu}
            > <RiMenu4Line size={20} />
            </div>
          </div>
        </div>
      </section>
	  
    </>
  );
}

export default NavBar;
